export function googleapi_dailyTrackerDataToJson(data: any[][], date: Date) {
  const values = (data ?? [])
    .filter((v) => v[0][0] && v[0][1])
    .map((v) => ({
      time: v[0],
      plate_number: v[1],
      member_number: v[2],
      member_status: v[3],
      member_expired_date: v[4],
      action: v[5],
      price: v[6],
      new_extend_member_detail: v[7],
      member_price: v[8],
      new_member_number: v[9],
      wax_member_flag: v[10],
      window_cleaning: v[11],
      window_price: v[12],
      product_upselling: v[13],
      total_upselling_price: v[14],
      payment_method: v[15],
      total_price: v[16],
      date,
    }));
  return values;
}
